(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yx-desktop-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHero(root) {
    var mq = window.matchMedia('(max-width: 767px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var vDesk = root.querySelector('.yx-hero-video__el--desktop');
    var vMob = root.querySelector('.yx-hero-video__el--mobile');

    function apply() {
      var on = mq.matches ? vMob : vDesk;
      var off = mq.matches ? vDesk : vMob;
      if (off && !off.paused) off.pause();
      if (!on || reduce) return;
      var src = on.getAttribute('data-src');
      if (!src) return;
      if (!on.getAttribute('src')) {
        on.setAttribute('src', src);
        on.load();
      }
      var p = on.play();
      if (p && p.catch) p.catch(function () {});
    }

    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
  }

  function run() {
    document.querySelectorAll('[data-yx-hero]').forEach(initHero);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();
})();
